import { query, request } from 'src/utils/request';
// TODO
// /api/zlbuser/business/identity/import/record
const urls = {
  userTypeList: '/api/user/dictionary/getUnifiedUserType',
  externalList: '/api/zlbuser/business/identity/list', // 人员列表接口
  institutionOperator: '/api/zlbuser/business/identity/institution/operator', // 获取业务人员下拉列表
  saveExternal: '/api/zlbuser/business/identity/save', // 手动新增
  getJobLevel: '/api/user/dictionary/getBusinessIdentityJobLevel', // 获取人员职级枚举
  changeExternalState: '/api/zlbuser/business/identity/state', // 启用停用
  getExternalDetail: '/api/zlbuser/business/identity/detail', // 获取详情
  getExternalEditDetail: '/api/zlbuser/business/identity/getEditInfo',
  deleteExternal: '/api/zlbuser/business/identity/delete', // 删除
  matchingOperator: '/api/zlbuser/business/identity/institution/matchingOperator', // 匹配内部人员
  getExternalImportRes: '/api/zlbuser/business/identity/import/result', // 获取excel解析结果
  saveExternalImportRes: '/api/zlbuser/business/identity/import/save', // 保存导入数据
  tempDownload: '/api/zlbuser/business/identity/template/download', // 下载模板接口
  checkExternal: '/api/zlbuser/business/identity/check', // checkExternal
  accountDetail: '/zlb/api/pay/bankCard/outer-user/detail', // 账户详情
  saveAccount: '/zlb/api/pay/bankCard/outer-user/save', // 账户保存
};
export function getUserTypeList(params) {
  return request(urls.userTypeList, { method: 'GET', params });
}

// 获取列表接口
export function getExternalList(params) {
  return request(urls.externalList, { method: 'GET', params });
}

// 外部用户-获取业务人员列表接口
export function getInstitutionOperator(params) {
  return request(urls.institutionOperator, { method: 'GET', params });
}

// 获取职级下拉枚举
export function getJobLevel() {
  return request(urls.getJobLevel);
}

// 修改用户状态
export function changeExternalState(data) {
  return request(urls.changeExternalState, { method: 'POST', data });
}

// 获取详情
export function getExternalDetail(params) {
  return request(urls.getExternalDetail, { method: 'GET', params });
}

// 获取编辑时详情
export function getExternalEditDetail(params) {
  return request(urls.getExternalEditDetail, { method: 'GET', params });
}

// 删除
export function deleteExternal(data) {
  return request(urls.deleteExternal, { method: 'POST', data });
}

// 保存
export function saveExternal(data) {
  return request(urls.saveExternal, { method: 'POST', data });
}

// 匹配内部人员
export function matchingOperator(params) {
  return request(urls.matchingOperator, { method: 'GET', params });
}

// 获取excel解析结果
export function getExternalImportRes(params) {
  return request(urls.getExternalImportRes, { method: 'GET', params });
}

// 保存导入数据
export function saveExternalImportRes(data) {
  return request(urls.saveExternalImportRes, { method: 'POST', data });
}

// 下载模板链接
export function tempDownload() {
  return request(urls.tempDownload, { method: 'GET' });
}

// 验证身份证 + 手机号
export function checkExternal(data) {
  return request(urls.checkExternal, { method: 'POST', data });
}

// 查询账户信息
export function getAccountDetail(data) {
  return request(urls.accountDetail, { method: 'POST', data });
}

// 保存账户信息
export function saveAccount(data) {
  return request(urls.saveAccount, { method: 'POST', data });
}

// 获取人员部门树
export async function getZlbUserDepartsTree(params) {
  return query('/api/zlbuser/institution/department/tree', { params });
}

export async function getZlbUserDepartsTreeByInstitutionId(params) {
  return query('/api/user/institution/department/tree', { params });
}
